


















import { Component, Vue } from 'vue-property-decorator'
import Logo from '@/assets/svg/logo.svg'
import LangSwitcher from '@/assets/svg/lang-switcher.svg?inline'
import { ILang } from '@/interfaces/lang.interface'

@Component({
  components: {
    LangSwitcher
  }
})
export default class Navbar extends Vue {
  public langs: ILang[] = [
    {
      code: 'ru',
      label: 'РУС'
    },
    {
      code: 'en',
      label: 'ENG'
    },
    {
      code: 'kk',
      label: 'ҚАЗ'
    }
  ]

  get logo() {
    return Logo
  }
}
